<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/produto&servico', query: $route.query }">
        Cadastro/Produtos e Serviços/Produtos e Serviços
      </router-link>
      <label class="labelBar"> / </label>
      <label> Editar</label>
    </div>
    <tab-navegacao-produto />
    <v-container fluid>
      <div style="position: absolute; right: 0">
        <avatar
          ref="avatar"
          :styleTile="true"
          :title="title"
          :isAllowed="!readOnly"
        />
      </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <formulario
          ref="formulario"
          :grupos="filteredGrupo"
          :subGrupos="filteredSubGrupo"
          :marcas="filteredMarca"
          :unidadesMedida="filteredUndMedia"
          :produtos="filteredProduto"
          :conversoes="conversoes"
          :possuiConversao="produto.possuiConversao"
          :departamentos="departamentos"
          :isAllowed="readOnly"
        />
      </v-form>
      <v-row align="center">
        <v-col cols="12" sm="2">
          <v-checkbox
            v-model="produto.ativo"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="3">
          <v-checkbox
            v-model="produto.possuiConversao"
            label="Possui Conversão"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="1">
          <v-tooltip bottom v-if="!readOnly">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                fab
                small
                v-bind="attrs"
                v-on="on"
                @click="addLista()"
                class="white--text"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Adicionar lista</span>
          </v-tooltip>
        </v-col>
        <v-col class="text-right">
          <v-btn
            :to="{ path: '/produto&servico', query: $route.query }"
            color="error"
            class="mr-4"
            v-if="!readOnly"
          >
            Voltar
          </v-btn>
          <v-btn
            :to="{ path: '/produto&servico', query: $route.query }"
            color="success"
            class="mr-4"
            v-else
          >
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-card :disabled="!produto.possuiConversao">
        <v-data-table
          :headers="headers"
          hide-default-footer
          :items-per-page="-1"
          :items="conversoes"
        >
          <template v-slot:item.ativo="{ item }">
            {{ item.ativo ? "Ativo" : "Inativo" }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom v-if="!readOnly">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="error"
                  @click="remove(item.id)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-close-thick
                </v-icon>
              </template>
              <span>Remover conversão</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-dialog
      style="z-index: 9999"
      v-model="showModal"
      persistent
      max-width="750px"
      ><v-card>
        <v-card-title>
          <span class="headline">Adicionar Produto / Serviço</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div style="position: absolute; right: 0">
              <avatar ref="avatarFrmAdd" :styleTile="true" :title="title" />
            </div>
            <v-form ref="form2" v-model="validFrm2" lazy-validation>
              <formulario
                ref="frmAdd"
                :grupos="filteredGrupo"
                :subGrupos="filteredSubGrupo"
                :marcas="filteredMarca"
                :unidadesMedida="filteredUndMedia"
                :departamentos="departamentos"
              />
            </v-form>
          </v-container> </v-card-text
        ><v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" class="mr-4" @click="showModal = false">
            Voltar
          </v-btn>
          <v-btn color="success" class="mr-4" @click="enviarFrmAdd">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TabNavegacaoProduto from "../../Tabs/TabCadastroProduto";
import {
  enviarProdutoAsync,
  editarProdutoAsync,
} from "../../../services/produtoService";
import { mapState, mapActions } from "vuex";
import Formulario from "./Formulario";
import Avatar from "../../Avatar/AvatarCard";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarGrupo",
  data: () => ({
    overlay: false,
    valid: true,
    showModal: false,
    title: "Upload Imagem",
    listaConversoes: null,
    readOnly: false,
    conversoes: [],
    headers: [
      {
        text: "Id",
        align: "start",
        value: "id",
      },
      { text: "Produto", value: "descricao" },
      { text: "Código", value: "codigo" },
      { text: "Und. Med ", value: "unidadeMedida" },
      { text: "Grupo ", value: "grupo" },
      { text: "SubGrupo ", value: "subGrupo" },
      { text: "Marca ", value: "marca" },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState("grupoProduto", ["gruposProduto", "subGruposProduto"]),
    ...mapState("marca", ["marcas"]),
    ...mapState("unidadeMedida", ["unidadesMedida"]),
    ...mapState("produto", ["produto", "produtos"]),
    ...mapState("departamento", ["departamentos"]),
    filteredMarca() {
      return this.marcas.filter((m) => {
        return m.ativo === true;
      });
    },
    filteredUndMedia() {
      return this.unidadesMedida.filter((u) => {
        return u.ativo === true;
      });
    },
    filteredGrupo() {
      return this.gruposProduto.filter((g) => {
        return g.ativo === true;
      });
    },
    filteredSubGrupo() {
      return this.subGruposProduto.filter((s) => {
        return s.ativo === true;
      });
    },
    filteredProduto() {
      return this.produtos.filter((p) => {
        return p.ativo === true;
      });
    },
    filteredConversoes() {
      if (this.produto.conversoes != null) {
        return this.produto.conversoes.filter((c) => {
          return c.ativo === true;
        });
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions("produto", [
      "atualizarProdutos",
      "atualizarProduto",
      "addProduto",
      "updateProduto",
    ]),
    async enviar() {
      if (this.$refs.form.validate()) {
        if (
          this.produto.possuiConversao &&
          (this.conversoes == null || this.conversoes.length == 0)
        ) {
          this.$alert("É necessário ter conversões adicionadas", "", "error");
          return;
        }
        this.overlay = true;
        var img = this.$refs.avatar.getImg();
        const resposta = await editarProdutoAsync(
          this.produto.id,
          //parseInt(this.$refs.formulario.tipo),
          this.$refs.formulario.tipos,
          this.$refs.formulario.descricao,
          this.$refs.formulario.codigo,
          this.$refs.formulario.grupoSelected.id,
          this.$refs.formulario.subGrupoSelected.id,
          this.$refs.formulario.marcaSelected.id,
          this.$refs.formulario.unidadeMedidaSelected.id,
          this.$refs.formulario.departamentoSelected.id,
          this.produto.possuiConversao,
          img,
          this.produto.ativo,
          this.conversoes
        );
        if (!resposta || resposta.message || resposta.Message) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.$alert(
            resposta && (resposta.message || resposta.Message) ? resposta.message || resposta.Message : "",
            "Desculpe, falha na operação!",
            "error"
          );
        } else {
          this.updateProduto(this.mountObjProduto(resposta));
          this.$store.dispatch("ui/showSnackbar", {
            text: "Atualizado com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push({
            path: "/produto&servico",
            query: this.$route.query,
          });
        }
      }
    },
    remove(index) {
      this.produto.conversoes = this.produto.conversoes.filter(
        (c) => c.id != index
      );
    },
    addLista() {
      this.showModal = true;
    },
    async enviarFrmAdd() {
      if (this.$refs.form2.validate()) {
        var img = this.$refs.avatarFrmAdd.getImg();
        const resposta = await enviarProdutoAsync(
          //parseInt(this.$refs.frmAdd.tipo),
          this.$refs.frmAdd.tipos,
          this.$refs.frmAdd.descricao,
          this.$refs.frmAdd.codigo,
          this.$refs.frmAdd.grupoSelected.id,
          this.$refs.frmAdd.subGrupoSelected.id,
          this.$refs.frmAdd.marcaSelected.id,
          this.$refs.frmAdd.unidadeMedidaSelected.id,
          this.$refs.frmAdd.departamentoSelected.id,
          false,
          img,
          null
        );
        if (resposta == 0) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.addProduto(this.mountObjProdutoFromModal(resposta));
          //this.atualizarProdutos();
          this.showModal = false;
          this.$refs.form2.reset();
        }
      }
    },
    obterIdProdutoSalvo(produtoSalvo) {
      if (produtoSalvo && typeof produtoSalvo === "object") {
        return produtoSalvo.id || produtoSalvo.Id;
      }

      return produtoSalvo;
    },
    mountObjProduto(produtoSalvo) {
      var produto = new Object();
      produto.id = this.obterIdProdutoSalvo(produtoSalvo) || this.produto.id;
      //produto.tipo = this.$refs.formulario.tipo;
      produto.tipos = this.$refs.formulario.tipos;
      produto.descricao = this.$refs.formulario.descricao;
      produto.codigo = this.$refs.formulario.codigo;
      produto.idGrupo = this.$refs.formulario.grupoSelected.id;
      produto.idSubGrupo = this.$refs.formulario.subGrupoSelected.id;
      produto.idMarca = this.$refs.formulario.marcaSelected.id;
      produto.idDepartamento = this.$refs.formulario.departamentoSelected.id;
      produto.idUnidadeMedida = this.$refs.formulario.unidadeMedidaSelected.id;
      produto.unidadeMedida =
        this.$refs.formulario.unidadeMedidaSelected.descricao;
      produto.grupo = this.$refs.formulario.grupoSelected.descricao;
      produto.subGrupo = this.$refs.formulario.subGrupoSelected.descricao;
      produto.marca = this.$refs.formulario.marcaSelected.descricao;
      produto.departamento =
        this.$refs.formulario.departamentoSelected.descricao;
      produto.imagem = this.$refs.avatar.getImg();
      produto.ativo = this.produto.ativo;
      produto.conversoes = this.produto.conversoes;
      return produto;
    },
    mountObjProdutoFromModal(produtoSalvo) {
      var produto = new Object();
      produto.id = this.obterIdProdutoSalvo(produtoSalvo);
      //produto.tipo = this.$refs.frmAdd.tipo;
      produto.tipos = this.$refs.frmAdd.tipos;
      produto.descricao = this.$refs.frmAdd.descricao;
      produto.codigo = this.$refs.frmAdd.codigo;
      produto.idGrupo = this.$refs.frmAdd.grupoSelected.id;
      produto.idSubGrupo = this.$refs.frmAdd.subGrupoSelected.id;
      produto.idMarca = this.$refs.frmAdd.marcaSelected.id;
      produto.idDepartamento = this.$refs.frmAdd.departamentoSelected.id;
      produto.idUnidadeMedida = this.$refs.frmAdd.unidadeMedidaSelected.id;
      produto.unidadeMedida = this.$refs.frmAdd.unidadeMedidaSelected.descricao;
      produto.grupo = this.$refs.frmAdd.grupoSelected.descricao;
      produto.subGrupo = this.$refs.frmAdd.subGrupoSelected.descricao;
      produto.marca = this.$refs.frmAdd.marcaSelected.descricao;
      produto.departamento = this.$refs.frmAdd.departamentoSelected.descricao;
      produto.imagem = this.$refs.avatarFrmAdd.getImg();
      produto.ativo = true;
      produto.conversoes = null;
      return produto;
    },
    filtrarConversoes() {
      if (this.produto.conversoes != null) {
        this.conversoes = this.produto.conversoes.filter((c) => {
          return c.ativo === true;
        });
      }
    },
  },
  mounted() {
    this.readOnly = !getUserPermission(6);
    this.$refs.formulario.fillForm(this.produto);
    if (this.produto.imagem) {
      this.$refs.avatar.setImg(this.produto.imagem);
    }
  },
  created: async function () {
    this.filtrarConversoes();
  },
  components: {
    TabNavegacaoProduto,
    Avatar,
    Formulario,
  },
};
</script>
